import AdventureBookingForm from "@/components/feature/AdventureBookingForm";

export default function BookingSailingPage() {
  return <AdventureBookingForm activity="sailing" />;
}